import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/imgs/snore/waveforms-demo.png';
import _imports_1 from '../../assets/imgs/snore/frequency-demo.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-213333e6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = ["oversea"];
var _hoisted_2 = {
  key: 0,
  class: "loading"
};
var _hoisted_3 = {
  class: "snore-lists"
};
var _hoisted_4 = {
  class: "snore-list"
};
var _hoisted_5 = {
  class: "title"
};
var _hoisted_6 = {
  class: "content"
};
var _hoisted_7 = {
  class: "snore-list"
};
var _hoisted_8 = {
  class: "title"
};
var _hoisted_9 = {
  class: "content"
};
var _hoisted_10 = {
  class: "snore-data"
};
var _hoisted_11 = {
  class: "snore-text"
};
var _hoisted_12 = {
  class: "snore-data"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "unit"
  }, "dB", -1);
});

var _hoisted_14 = {
  class: "snore-text"
};
var _hoisted_15 = {
  class: "snore-range"
};
var _hoisted_16 = {
  class: "max"
};
var _hoisted_17 = {
  class: "num"
};

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "unit"
  }, "dB", -1);
});

var _hoisted_19 = {
  class: "max"
};
var _hoisted_20 = {
  class: "num"
};

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "unit"
  }, "dB", -1);
});

var _hoisted_22 = {
  class: "snore-list"
};
var _hoisted_23 = {
  class: "title"
};
var _hoisted_24 = {
  key: 1,
  class: "waveforms-demo-img",
  src: _imports_0
};
var _hoisted_25 = {
  class: "snore-list"
};
var _hoisted_26 = {
  class: "title"
};
var _hoisted_27 = {
  key: 0,
  class: "snore-list"
};
var _hoisted_28 = {
  class: "title"
};
var _hoisted_29 = {
  class: "frequency-trend-label-lists"
};
var _hoisted_30 = {
  class: "frequency-trend-label-list"
};

var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "frequency-tag high"
  }, null, -1);
});

var _hoisted_32 = {
  class: "frequency-texts"
};
var _hoisted_33 = {
  class: "frequency-label"
};
var _hoisted_34 = {
  class: "frequency-label"
};
var _hoisted_35 = {
  class: "frequency-trend-label-list"
};

var _hoisted_36 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "frequency-tag medium"
  }, null, -1);
});

var _hoisted_37 = {
  class: "frequency-texts"
};
var _hoisted_38 = {
  class: "frequency-label"
};
var _hoisted_39 = {
  class: "frequency-label"
};
var _hoisted_40 = {
  class: "frequency-trend-label-list"
};

var _hoisted_41 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "frequency-tag low"
  }, null, -1);
});

var _hoisted_42 = {
  class: "frequency-texts"
};
var _hoisted_43 = {
  class: "frequency-label"
};
var _hoisted_44 = {
  class: "frequency-label"
};
var _hoisted_45 = {
  class: "snore-list"
};
var _hoisted_46 = {
  class: "title"
};
var _hoisted_47 = {
  key: 1,
  class: "frequency-demo-img",
  src: _imports_1
};
var _hoisted_48 = {
  class: "frequency-trend-label-lists"
};
var _hoisted_49 = {
  class: "frequency-trend-label-list"
};

var _hoisted_50 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "frequency-tag high"
  }, null, -1);
});

var _hoisted_51 = {
  class: "frequency-texts"
};
var _hoisted_52 = {
  class: "frequency-label"
};
var _hoisted_53 = {
  class: "frequency-label"
};
var _hoisted_54 = {
  class: "frequency-trend-label-list"
};

var _hoisted_55 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "frequency-tag medium"
  }, null, -1);
});

var _hoisted_56 = {
  class: "frequency-texts"
};
var _hoisted_57 = {
  class: "frequency-label"
};
var _hoisted_58 = {
  class: "frequency-label"
};
var _hoisted_59 = {
  class: "frequency-trend-label-list"
};

var _hoisted_60 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "frequency-tag low"
  }, null, -1);
});

var _hoisted_61 = {
  class: "frequency-texts"
};
var _hoisted_62 = {
  class: "frequency-label"
};
var _hoisted_63 = {
  class: "frequency-label"
};
var _hoisted_64 = {
  key: 0,
  class: "open-vip-box"
};
var _hoisted_65 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_loading = _resolveComponent("van-loading");

  var _component_no_net_tip = _resolveComponent("no-net-tip");

  var _component_VideoList = _resolveComponent("VideoList");

  var _component_van_icon = _resolveComponent("van-icon");

  var _component_decibel_chart = _resolveComponent("decibel-chart");

  var _component_PieChart = _resolveComponent("PieChart");

  var _component_PointChart = _resolveComponent("PointChart");

  return _openBlock(), _createElementBlock("div", {
    class: "snore-data",
    oversea: $data.oversea
  }, [$data.isloading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_loading, {
    size: "24",
    color: "#3F96F3"
  })])) : $data.noNet ? (_openBlock(), _createBlock(_component_no_net_tip, {
    key: 1
  })) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("message.snore.snoreRecord")), 1), _createElementVNode("div", _hoisted_6, [_createVNode(_component_VideoList, {
    ref: "videoLists",
    "snore-list": $data.snoreDetail.displayRecords,
    snoreDetail: $data.snoreDetail
  }, null, 8, ["snore-list", "snoreDetail"])])])]), _createElementVNode("div", {
    class: _normalizeClass($data.flag === 1 ? 'snore-lists' : 'snore-lists unlock')
  }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("message.snore.snoreData")), 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_10, _toDisplayString($data.flag != 1 ? $options.transferSeconds($data.snoreDetailDemo.snoringDuration) : $options.transferSeconds($data.snoreDetail.snoringDuration / 1000)), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("message.snore.snoreDuration")), 1)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_12, [_createTextVNode(_toDisplayString($data.flag != 1 ? $data.snoreDetailDemo.avgDecibel : $data.snoreDetail.avgDecibel), 1), _hoisted_13]), _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("message.snore.avgSnoreDb")), 1)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", null, [_createVNode(_component_van_icon, {
    class: "icon",
    name: "back-top",
    color: "#ff5b18"
  }), _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("message.sleep.highest")), 1), _createElementVNode("span", _hoisted_17, _toDisplayString($data.flag != 1 ? $data.snoreDetailDemo.maxDecibel : $data.snoreDetail.maxDecibel), 1), _hoisted_18]), _createElementVNode("div", null, [_createVNode(_component_van_icon, {
    class: "icon rotate180",
    name: "back-top",
    color: "#008be8"
  }), _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("message.sleep.lowest")), 1), _createElementVNode("span", _hoisted_20, _toDisplayString($data.flag != 1 ? $data.snoreDetailDemo.minDecibel : $data.snoreDetail.minDecibel), 1), _hoisted_21])])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("message.snore.snoreWaveforms")), 1), $data.flag == 1 ? (_openBlock(), _createBlock(_component_decibel_chart, {
    key: 0,
    "decibel-lists": $data.decibelLists,
    startTime: $data.startTime,
    "end-time": $data.endTime,
    "center-time": $data.centerTime
  }, null, 8, ["decibel-lists", "startTime", "end-time", "center-time"])) : (_openBlock(), _createElementBlock("img", _hoisted_24))]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("message.snore.snoreDbRatio")), 1), _createVNode(_component_PieChart, {
    details: $data.flag != 1 ? $data.snoreDetailDemo : $data.snoreDetail
  }, null, 8, ["details"])]), false ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("message.snore.snoreFrequency")), 1), _createVNode(_component_PieChart, {
    type: "frequency",
    details: $data.flag != 1 ? $data.snoreDetailDemo : $data.snoreDetail
  }, null, 8, ["details"]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, [_createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('message.snore.high')), 1), _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('message.snore.softSnore')), 1)])]), _createElementVNode("div", _hoisted_35, [_hoisted_36, _createElementVNode("div", _hoisted_37, [_createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('message.snore.medium')), 1), _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('message.snore.uvulaSnore')), 1)])]), _createElementVNode("div", _hoisted_40, [_hoisted_41, _createElementVNode("div", _hoisted_42, [_createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('message.snore.low')), 1), _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t('message.snore.tongueSnore')), 1)])])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t("message.snore.snoreFrequencyTrend")), 1), $data.flag == 1 ? (_openBlock(), _createBlock(_component_PointChart, {
    key: 0,
    list: $data.frequencyLists,
    startTime: $data.startTime,
    "end-time": $data.endTime
  }, null, 8, ["list", "startTime", "end-time"])) : _createCommentVNode("", true), $data.flag != 1 ? (_openBlock(), _createElementBlock("img", _hoisted_47)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_hoisted_50, _createElementVNode("div", _hoisted_51, [_createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t('message.snore.high')), 1), _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t('message.snore.softSnore')), 1)])]), _createElementVNode("div", _hoisted_54, [_hoisted_55, _createElementVNode("div", _hoisted_56, [_createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t('message.snore.medium')), 1), _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t('message.snore.uvulaSnore')), 1)])]), _createElementVNode("div", _hoisted_59, [_hoisted_60, _createElementVNode("div", _hoisted_61, [_createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t('message.snore.low')), 1), _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.$t('message.snore.tongueSnore')), 1)])])])])], 2), $data.flag != 1 ? (_openBlock(), _createElementBlock("div", _hoisted_64, [_createElementVNode("div", {
    class: "btn",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.goOpenVipPage();
    })
  }, [_createElementVNode("img", {
    src: $data.imgVip,
    alt: ""
  }, null, 8, _hoisted_65), _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.sleep.openVipToSee")), 1)])])) : _createCommentVNode("", true)], 64))], 8, _hoisted_1);
}